import { styled } from '@mui/material'

export const GenEdRowContainer = styled('div')({
  display: 'grid',
  gridTemplateColumns: '160px 70px 280px 1fr 160px',
  columnGap: '30px',
  alignItems: 'center',
  justifyItems: 'center',
  padding: '16px 24px',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '16px',
})
